"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BorderTop = exports.ClearBtn = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../../utils/styleConsts");

var styles = function styles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;min-width:100%;box-sizing:border-box;top:100%;overflow:auto;padding:8px 0;background-color:", color.dark.mars, ";border-radius:", _styleConsts.borderRadius, ";z-index:2;transition:all 0.3s;.Loader{display:block;margin:10px auto;}")
  );
};

var StyledList = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ciwdo40"
})(styles));

var clearBtnStyle = function clearBtnStyle(_ref2) {
  var color = _ref2.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-family:ProximaNova;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.43;letter-spacing:normal;color:", color.red, ";padding:8px 16px;cursor:pointer;margin-top:4px;margin-bottom:-4px;:hover{background:", color.redBackground, ";}")
  );
};

var ClearBtn = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ciwdo41"
})(clearBtnStyle));
exports.ClearBtn = ClearBtn;

var borderTop = function borderTop(_ref3) {
  var color = _ref3.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-top:4px;border-top:1px solid ", color.grey4, ";")
  );
};

var BorderTop = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-ciwdo42"
})(borderTop));
exports.BorderTop = BorderTop;
var _default = StyledList;
exports.default = _default;